import React, { useMemo, useCallback } from 'react';
import Input from '../input';
import { InputIconConfig } from '../input/types';

type SearchProps = {
  value: string;
  searchPlaceholder?: string;
  onChange: (value: string) => void;
  onKeyDown?: (
    value: string,
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => void;
  autoFocusSearch?: boolean;
  showClearIcon?: boolean;
};

const Search: React.FC<SearchProps> = ({
  value,
  onChange,
  onKeyDown,
  searchPlaceholder = 'Search here',
  autoFocusSearch = false,
  showClearIcon = false,
}) => {
  const handleClear = useCallback(() => {
    onChange('');
  }, [onChange]);

  const icons = useMemo(() => {
    const iconList: InputIconConfig[] = [
      {
        place: Input.IconPlace.Left,
        identifier: 'search',
      },
    ];

    // Add clear icon only if showClearIcon is true and there's a value to clear
    if (showClearIcon && value && value?.length > 0) {
      iconList.push({
        place: Input.IconPlace.Right,
        identifier: 'close-o',
        onClick: handleClear,
      });
    }

    return iconList;
  }, [showClearIcon, value, handleClear]);

  return (
    <div className="transfer-search">
      <Input
        placeholder={searchPlaceholder}
        icons={icons}
        value={value}
        onChange={onChange}
        className="transfer-search-input"
        onKeyDown={(event) => onKeyDown?.(value, event)}
        autoFocus={autoFocusSearch}
      />
    </div>
  );
};

export default React.memo(Search);
